import { apiClient } from './api/client';

export const EMPTY_MEETING_WELCOME = {
  reportDate: '',
  closedBusiness: '',
  yearToDate: '',
  onTrack: '',
  dailyAverage: '',
  memberCount: '',
  averageSeatValue: '',
};

export function normalizeMeetingWelcome(value = {}) {
  return Object.fromEntries(
    Object.keys(EMPTY_MEETING_WELCOME).map((key) => [
      key,
      value?.[key] === null || value?.[key] === undefined ? '' : String(value[key]),
    ]),
  );
}

export function formatMeetingWelcomeCurrency(value) {
  const raw = String(value ?? '').trim();
  const amount = Number(raw);
  if (!raw || !Number.isFinite(amount)) return '—';
  const fractionLength = raw.includes('.') ? Math.min(2, raw.split('.')[1].length) : 0;
  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: fractionLength,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatMeetingWelcomeDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value ?? ''));
  if (!match) return '';
  const [, year, month, day] = match;
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), 12));
  return new Intl.DateTimeFormat('en-CA', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}

export async function getMeetingWelcome() {
  return apiClient.get('/api/public/meeting-welcome', { skipAuth: true });
}

export async function updateMeetingWelcome(values) {
  return apiClient.patch('/api/executive/meeting-welcome', {
    ...values,
    memberCount: Number(values.memberCount),
  });
}
